import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdDelete } from 'react-icons/md';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css'; // Import swiper bundle CSS


const JeweleryCard = ({ jewelry, onDelete }) => {

  const navigate = useNavigate();
  const [admin, setAdmin] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const isAdmin = localStorage.getItem('admin');
    setAdmin(isAdmin);
  }, []);

  const handleClick = (event) => {
    if (!showModal) {
      navigate(`/details/${jewelry._id}`);
    }
  };

  const handleDeleteClick = (event) => {
    event.stopPropagation(); 
    setShowModal(true);
  };

  const handleDeleteConfirm = () => {
    
    onDelete(jewelry._id);
   
    setShowModal(false);
  
  };

  const handleModalClose = (event) => {
    event.stopPropagation();
    setShowModal(false);
  };

  return (

     <div className="relative bg-gray-50 shadow-md rounded-lg p-4 cursor-pointer" onClick={handleClick}>
    <div className="swiper-container h-72">
      <Swiper
        spaceBetween={10}
        slidesPerView={1} // Display only one slide (either image or video) at a time
        loop={true}
        className="h-full"
      >
        {jewelry.image && (
          <SwiperSlide>
            <img src={jewelry.image} alt={jewelry.itemName} className="h-full w-full object-cover rounded-lg" />
          </SwiperSlide>
        )}
         {jewelry.image2 && (
          <SwiperSlide>
            <img
              src={jewelry.image2}
              alt={jewelry.itemName}
              className="h-full w-full object-cover rounded-lg"
            />
          </SwiperSlide>
        )}
        {jewelry.video && (
          <SwiperSlide>
            <video controls className="h-full w-full object-cover rounded-lg">
              <source src={jewelry.video} type="video/mp4" />
            </video>
          </SwiperSlide>
        )}
      </Swiper>
    </div>

    {admin &&
      <div className="absolute bottom-2 right-2">
        <button className="bg-gray-500 text-white rounded-full p-2" onClick={handleDeleteClick}>
          <MdDelete size={24} />
        </button>
      </div>
    }

    <h2 className="text-lg font-bold mt-2">Title: {jewelry.itemName}</h2>
    {admin &&
      <p className="text-gray-700">Price: {jewelry.totalRate}</p>
    }

    {showModal &&
      <div
        className="fixed inset-0 z-50 flex items-center justify-center w-full h-full bg-black bg-opacity-50"
        onClick={handleModalClose}
      >
        <div
          className="bg-white rounded-lg shadow dark:bg-gray-700 relative p-4 w-full max-w-md"
          onClick={(e) => e.stopPropagation()} // Prevent modal close when clicking inside the modal
        >
          <button
            type="button"
            className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
            onClick={handleModalClose}
          >
            <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1l6 6m0 0l6 6M7 7l6-6M7 7l-6 6" />
            </svg>
            <span className="sr-only">Close modal</span>
          </button>
          <div className="p-4 md:p-5 text-center">
            <svg className="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">Are you sure you want to delete this item?</h3>
            <button
              onClick={handleDeleteConfirm}
              type="button"
              className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center"
            >
              Yes, I'm sure
            </button>
            <button
              type="button"
              className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
              onClick={handleModalClose}
            >
              No, cancel
            </button>
          </div>
        </div>
      </div>
    }
  </div>
   

   
    
  );
};

export default JeweleryCard;
